// extracted by mini-css-extract-plugin
export default {"mainCategory":"DefaultCategory_mainCategory__By1RX","allCategory":"DefaultCategory_allCategory__xqrqn"};